export interface StorageProvider {
  get(key: string): Promise<Uint8Array | null>;
  set(key: string, data: Uint8Array): Promise<void>;
  delete(key: string): Promise<void>;
  list(prefix: string): Promise<string[]>;
  isAvailable(): boolean;
  getStorageType(): 'indexeddb' | 'memory';
}

export const STORAGE_KEYS = {
  romCache: (modelId: string): string => `rom_cache:${modelId}`,
  snapshot: (slotId: string): string => `snapshot:${slotId}`,
  userModelConfig: (modelId: string): string => `user_model:${modelId}:config`,
  userModelRom: (modelId: string): string => `user_model:${modelId}:rom`,
  userModelImage: (modelId: string): string => `user_model:${modelId}:image`,
  settings: 'settings:ui' as string,
};
